import React from "react";
import {
    AccountBalanceWalletRounded,
    BarChartRounded,
    CardGiftcardRounded,
    DashboardRounded,
    PeopleAltRounded,
    ReceiptLongRounded,
    SettingsRounded,
    SupportAgentRounded,
} from "@mui/icons-material";

export const NavigationMenu = [
    {
        segment: 'dashboard',
        title: 'پیشخوان',
        icon: <DashboardRounded />,
    },
    {
        kind: 'divider',
    },
    {
        kind: 'header',
        title: 'پرسنل و اعتباردهی',
    },
    {
        segment: 'allocations',
        title: 'تخصیص اعتبار',
        icon: <CardGiftcardRounded />,
    },
    {
        segment: 'personnel',
        title: 'لیست پرسنل',
        icon: <PeopleAltRounded />,
    },
    {
        kind: 'divider',
    },
    {
        kind: 'header',
        title: 'امور مالی سازمان',
    },
    {
        segment: 'finance/wallet',
        title: 'کیف‌پول و شارژ حساب',
        icon: <AccountBalanceWalletRounded />,
    },
    {
        segment: 'finance/transactions',
        title: 'تراکنش‌های مصرف پرسنل',
        icon: <ReceiptLongRounded />,
    },
    {
        kind: 'divider',
    },
    {
        kind: 'header',
        title: 'گزارش‌های تحلیلی',
    },
    {
        segment: 'reports',
        title: 'گزارش‌های تحلیلی',
        icon: <BarChartRounded />,
    },
    {
        kind: 'divider',
    },
    {
        kind: 'header',
        title: 'پشتیبانی و تنظیمات',
    },
    {
        segment: 'support',
        title: 'پشتیبانی و تیکت‌ها',
        icon: <SupportAgentRounded />,
    },
    {
        segment: 'settings',
        title: 'تنظیمات سازمان',
        icon: <SettingsRounded />,
    },
];
